// The live dashboard's All branches view (GET /floor/branches).

/** One branch's floor at a glance (store.FloorFigures). Waits are calling waits. */
export interface FloorFigures {
  branchId: string
  waiting: number
  serving: number
  aside: number
  longestWaitSec: number
  avgWaitSec: number
  overTarget: number
  /** Waiting past 80% of their target, not yet over it. */
  nearTarget: number
  desks: number
  desksOpen: number
  desksOnBreak: number
  requests: number
  /** The report's Served for the branch's business day. */
  served: number
  /** Customers at a desk for over 15 minutes. */
  longServing: number
}

export interface FloorBranch extends FloorFigures {
  tenantId: string
  code: string
  name: string
  openNow: boolean
}

export interface FloorOverview {
  branches: FloorBranch[]
  totals: FloorFigures
}

export type FloorSort = 'name' | 'waiting' | 'longestWaitSec' | 'overTarget' | 'serving' | 'desksOpen' | 'requests'

/** Branches in the order a column asks: figures largest first, names A to Z.
 *  Ties fall back to the longest wait, then the name, so the order holds still between polls. */
export function sortBranches(branches: readonly FloorBranch[], by: FloorSort): FloorBranch[] {
  const byName = (a: FloorBranch, b: FloorBranch) => a.name.localeCompare(b.name) || a.code.localeCompare(b.code)
  return [...branches].sort((a, b) => {
    if (by === 'name') return byName(a, b)
    return b[by] - a[by] || b.longestWaitSec - a.longestWaitSec || byName(a, b)
  })
}

/** Whether a branch answers a typed search, by name or code. */
export function matchesFind(b: Pick<FloorBranch, 'name' | 'code'>, find: string): boolean {
  const q = find.trim().toLocaleLowerCase()
  return !q || b.name.toLocaleLowerCase().includes(q) || b.code.toLocaleLowerCase().includes(q)
}

/** The rail's search shows only past this many branches. */
export const FIND_FROM = 8
